import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MR',
    name: 'Martín R.',
    loc: '📍 Buenos Aires · Entrenador de Club',
    text: 'Compré un domingo a la noche. El lunes entré a la cancha con el plan exacto de la sesión. Las 25 semanas del Tomo 1 son exactamente lo que necesitaba. Nunca más improviso.'
  }, {
    initials: 'CS',
    name: 'Carolina S.',
    loc: '📍 Rosario · Entrenadora en Academia',
    text: 'El sistema del Tomo 2 me cambió todo. El primer mes, tres jugadores que llevaban meses estancados subieron de nivel.'
  }, {
    initials: 'DV',
    name: 'Diego V.',
    loc: '📍 Córdoba · Entrenador Independiente',
    text: 'El Tomo 5 de 101 Drills Pro es único en el mercado. Antes tardaba 1 hora en armar una sesión táctica. Ahora 5 minutos.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    loc: '📍 Tucumán · Entrenador en Club',
    text: 'El sistema de evaluación con fichas mensuales eliminó las preguntas de los padres. Ahora el jugador ve su progreso con números concretos.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    loc: '📍 Mendoza · Entrenadora de Vóley',
    text: 'Mi tasa de retención pasó del 40% al 80%. Solo aplicando el sistema del Tomo 6 y el Kit Táctico Pro en cada partido.'
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    loc: '📍 Santa Fe · Entrenadora de Vóley',
    text: 'Ahora entrego el Reglamento Interno en la primera sesión. Este mes no tuve ninguna queja sobre el tiempo de juego. Primera vez en mi carrera.'
  }, {
    initials: 'AR',
    name: 'Ana R.',
    loc: '📍 Salta · Entrenadora en Club',
    text: 'El Calendario de Temporada me organizó todo el año en una tarde. Ahora tengo los datos de cada evaluación desde la semana 1.'
  }];
  return <section className="py-20 px-4 bg-dark-DEFAULT border-t border-dark-border" data-id="element-257">
      <div className="max-w-6xl mx-auto" data-id="element-258">
        <div className="text-center mb-16" data-id="element-259">
          <h2 className="text-4xl md:text-5xl font-bebas mb-4" data-id="element-260">
            <span className="text-white" data-id="element-261">Lo que dicen los </span>
            <span className="text-brand-DEFAULT" data-id="element-262">
              entrenadores que ya lo usan
            </span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-263">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-6 rounded-xl flex flex-col" data-id="element-264">
              <div className="flex items-center space-x-4 mb-4" data-id="element-265">
                <div className="w-12 h-12 rounded-full bg-dark-border flex items-center justify-center text-brand-DEFAULT font-bold text-lg" data-id="element-266">
                  {t.initials}
                </div>
                <div data-id="element-267">
                  <h4 className="text-brand-DEFAULT font-bold" data-id="element-268">{t.name}</h4>
                  <p className="text-xs text-text-secondary" data-id="element-269">{t.loc}</p>
                </div>
              </div>
              <div className="flex space-x-1 mb-4" data-id="element-270">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} className="text-brand-gold fill-brand-gold" data-id="element-271" />)}
              </div>
              <p className="text-text-secondary text-sm italic leading-relaxed" data-id="element-272">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}